module.exports = __webpack_public_path__ + "img/banner1.59391763.jpg";